import { render, staticRenderFns } from "./ProductImageEditor.vue?vue&type=template&id=21b856ee&scoped=true&"
import script from "./ProductImageEditor.vue?vue&type=script&lang=js&"
export * from "./ProductImageEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b856ee",
  null
  
)

export default component.exports